export class ClientInfoResponse {
  success: boolean;
  payload: ClientBitsoInfo;
}

export class ClientBitsoInfo {
  client_id: string = '';
  first_name: string = '';
  last_name: string = '';
  second_last_name: string = '';
  status: string = '';
  daily_limit: string = '';
  monthly_limit: string = '';
  daily_remaining: string = '';
  monthly_remaining: string = '';
  cash_deposit_allowance: string = '';
  cellphone_number: string = '';
  cellphone_number_stored: string = '';
  email: string = '';
  email_stored: string = '';
  official_id: string = '';
  proof_of_residency: string = '';
  signed_contract: string = '';
  origin_of_funds: string = '';
  verification_level: number = 0;
  referral_code: string = '';
  country_of_residence: string = '';
  gravatar_img: string = '';
  account_creation_date: string = '';
  preferred_currency: string = '';
  enabled_two_factor_methods: string[] = [];
  business_name: string = '';
  gender: string = '';
  user_default_fiat_currency: string = '';
  date_of_birth: string = '';
  born_in_residence: string = '';
  tax_payer_type: string = '';
  entity_type: string = '';
  iba_enrolled: string = '';
}


export class CriptoActivoBitso {
  currency: string;
  available: number;
  locked: number;
  total: number;
  pending_deposit: number;
  pending_withdrawal: number;
}

export class CotizacionCryptoBitsoRequest {
    id: string;
    from_currency: string;
    to_currency: string;
    from_amount: number;
    to_amount: number;
}

export class ConfirmacionBodyBitsoResponse {
    success: boolean;
    payload: PayloadBitsoResponse | null;
}

export class PayloadBitsoResponse {
    oid: string | null;
}